export default {
  alternativeNext: {
    id: 'alternative-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'alternative-previous',
    defaultMessage: 'Previous',
  },
  alternativeClose: {
    id: 'alternative-close',
    defaultMessage: 'Close',
  },
}
